import React, { useEffect, useState } from 'react'
import { Table, Tooltip, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { changeFormatdate } from '../../utils/formatDate'
import axiosRc from '../../config/axios-rc'
import { getUserStorage } from '../../utils/localStorage'
import { AiFillCloseCircle, AiFillPrinter } from 'react-icons/ai'
import { ModalRc } from '../../components/modalRc'
import { useSetRecoilState } from 'recoil'
import { isLoadingState } from '../../recoil/states/default'

const MyJobTable = () => {
    const [datas, setDatas] = useState([])
    const setIsLoading = useSetRecoilState(isLoadingState)

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        const user = getUserStorage()
        if (user) {
            const _user = JSON.parse(user.data)
            const _query = `?email=${_user.email}&appProfileId=${_user.id}`;
            const { data } = await axiosRc.get(`/candidate/get_list_my_job/${_query}`);
            if (data) {
                setDatas(data)
            }
        }
    }

    const handleClickCancel = (record) => {
        console.log('handleClickCancel', record)
        const propsModal = {
            type: 'confirm',
            classModal: 'error',
            content: 'ต้องการยกเลิกการสมัคร ใช่หรือไม่?',
            okText: "ยืนยัน",
            onOk: () => {
                cancelApply(record)
            },
            onCancel: () => { },
        }
        ModalRc(propsModal)
    }

    const handlePrint = async (record) => {
        const propsModal = {
            type: 'confirm',
            classModal: 'info',
            content: 'ต้องการพิมพ์ใบสมัคร ใช่หรือไม่?',
            okText: "ยืนยัน",
            onOk: () => {
                printCandidateDocument(record)
            },
            onCancel: () => { },
        }
        ModalRc(propsModal)
    }

    const printCandidateDocument = async (record) => {
        setIsLoading(true)
        const arge = "?id=" + parseInt(record.id)
        const res = await axiosRc.get("candidate/exportpdf_candidate" + arge, {
            responseType: 'blob'
        })
        if (res?.data) {
            // window.location.href = res.request.responseURL
            const modifiedBlob = new Blob([res.data], { type: 'application/pdf' });
            const modifiedUrl = URL.createObjectURL(modifiedBlob);
            // Create an anchor element to trigger the download
            const anchor = document.createElement('a');
            anchor.href = modifiedUrl;
            anchor.download = (record?.candidateDocumentNo ?? 'document') + '.pdf'; // Set the filename
            anchor.click();

            // Clean up
            URL.revokeObjectURL(modifiedUrl);
            setIsLoading(false)
            message.success(`พิมพ์เอกสารสำเร็จ`)
        } else {
            setIsLoading(false)
        }
    }

    const cancelApply = async (record) => {
        const body = {
            id: record.id
        }
        const result = await axiosRc.put(`/candidate/cancel_apply`, body);
        if (result.status === 200) {
            message.success('ยกเลิกการสมัครสำเร็จ')
            await fetchData()
        }
        console.log('result', result)
    }

    const columns = [
        {
            title: 'ตำแหน่งงาน',
            dataIndex: 'positionName',
            width: '250px',
            key: 'posipositionNametion',
            render: (item, record, index) => <span>{`${record.positionCareerName ?? ''} ${record.orgUnitName ?? ''}`}</span>,
        },
        {
            title: 'หน่วยงาน',
            dataIndex: 'buName',
            width: '200px',
            key: 'buName',
            render: (item, record, index) => <span>{item}</span>,
        },
        // {
        //     title: 'สถานที่ทำงาน',
        //     dataIndex: 'address',
        //     width: '200px',
        //     key: 'address',
        //     render: (item, record, index) => <span>{item}</span>,
        // },
        // {
        //     title: 'จังหวัด',
        //     dataIndex: 'province',
        //     width: '150px',
        //     key: 'province',
        //     render: (item, record, index) => <span>{item}</span>,
        // },
        {
            title: 'วันที่สมัคร',
            dataIndex: 'applyDate',
            key: 'applyDate',
            width: '150px',
            align: 'center',
            render: (item, record, index) => {
                return <div className="apply-date">{changeFormatdate(record.applyDate)}</div>
            }
        },
        {
            title: 'สถานะ',
            dataIndex: 'status',
            width: '150px',
            key: 'status',
            render: (item, record, index) => <span>{item}</span>,
        },
        {
            title: '#',
            dataIndex: 'delete',
            key: 'delete',
            width: '100px',
            align: 'center',
            render: (item, record, index) => {
                const statusAccept = ['wait', 'comply', 'pass']
                return <div className='flex justify-between'>
                    {record.statusCode !== 'cancelApply' &&
                        <>
                            {/* ใบสมัครที่สามารถยกเลิกได้ จะมีแค่ รอการคัดกรอง อนุโลม ผ่านการคัดกรอง*/}
                            {statusAccept.includes(record.statusCode) && record.isDraft === false &&
                                <Tooltip title='ยกเลิกการสมัคร'>
                                    <AiFillCloseCircle className="delete-icon cursor-pointer" onClick={() => handleClickCancel(record)} />
                                </Tooltip>
                            }
                            <Tooltip title='พิมพ์ใบสมัคร'>
                                <AiFillPrinter className='print-icon cursor-pointer' onClick={() => handlePrint(record)} />
                            </Tooltip>
                        </>
                    }
                </div>
            }
        }
    ]

    const CustomPagination = ({ current, pageSize, total, onChange }) => {
        const totalPages = Math.ceil(total / pageSize);
        const [pageInput, setPageInput] = useState(current);

        const handlePageChange = (newPage) => {
            setPageInput(newPage);
            onChange(newPage, pageSize);
        };

        return (
            <div>
                <button disabled={current === 1} onClick={() => handlePageChange(current - 1)}>
                    Previous
                </button>
                <input
                    type="number"
                    min="1"
                    max={totalPages}
                    value={pageInput}
                    onChange={(e) => setPageInput(e.target.value)}
                />
                <button disabled={current === totalPages} onClick={() => handlePageChange(current + 1)}>
                    Next
                </button>
            </div>
        );
    };

    const [pagination, setPagination] = useState({ current: 1, pageSize: 2 });

    const handleTableChange = (pagination, filters, sorter) => {
        setPagination(pagination);
    };

    return (
        <Table
            columns={columns}
            dataSource={datas}
            rowKey={'id'}
            size='large'
            scroll={{ x: "max-content" }}
            pagination={{
                ...pagination,
                showSizeChanger: false,
                showQuickJumper: false,
                // showTotal: (total) => `Total ${total} items`,
                onChange: handleTableChange,
                itemRender: (page, type, originalElement) => {
                    if (type === 'prev') {
                        return (
                            <>
                                <FontAwesomeIcon
                                    icon={faCaretLeft} />
                            </>
                        );
                    }
                    if (type === 'next') {
                        return (
                            <>
                                <FontAwesomeIcon
                                    icon={faCaretRight} />
                            </>
                        );
                    }
                    return originalElement;
                },
                locale: { items_per_page: '' },
                // pageSizeOptions: ['2', '4', '6'],
                pageSize: 10,
                total: datas.length,
                responsive: true,
                pagination: (props) => <CustomPagination {...props} />,
            }}
        />
    )
}

export default MyJobTable